import React from "react";
import DragSensorCells from "./DragSensorCells";
import styled, { css } from "styled-components";
//import { Day } from "./Day";
import _ from "lodash";
import { connect } from "react-redux";
import EventsContainer from "./EventsContainer";
import { hot } from "react-hot-loader";

import {
    selectWeekCount,
    selectRowCount,
    selectArrangedJobpostingsAsArray,
    selectSelectedJobpostingID,
    selectRawJobpostings,
    selectCopyPasteEvent,
    selectEvents,canCreate,
    canDelete,
    canUpdate,
} from "./selectors";
import { removeTrack, setCurrTrackID, pasteEvent } from "./actions";
import { IconButton } from "@material-ui/core";
import moment from "moment";
import ClearIcon from "@material-ui/icons/Clear";
import AddIcon from "@material-ui/icons/Add";
import CopyPasteIcon from "@material-ui/icons/FileCopy";
export const TrackContainer = styled.div`
    height: ${(props) => props.rows * 180}px;
    min-height: 180px;
    padding-bottom: 4px;
    display: grid;
    width: 100%;
    grid-template-rows: 1fr;
    grid-template-columns: ${(props) => props.sidebarWidth}px 1fr;
    overflow: hidden;
`;

export const IconButtonContainer = styled.div`
    grid-column-start: ${(props) => props.column};
    grid-column-end: ${(props) => props.column};
    grid-row-start: ${(props) => props.row};
    grid-row-end: ${(props) => props.row};
    max-width: 20px;
    max-height: 20px;
    color: white;
`;

export const StyledIconButton = styled(IconButton)`
    && {
        width: 22px;
        height: 22px;
        color: ${(props) => props.color};
    }
`;
const TrackSidebar = styled.div`
    grid-row-start: 1;
    grid-row-end: 1;
    grid-column-start: 1;
    grid-column-end: 1;
    background: #0188cc;
    display: grid;
    grid-template-rows: 50px 1fr 1fr;
    grid-template-columns: 20px 1fr 20px;
`;

const IconStyles = css`
    max-width: 20px;
    max-height: 20px;
`;

const StyledClearIcon = styled(ClearIcon)`
    ${IconStyles}
`;
const StyledAddIcon = styled(AddIcon)`
    ${IconStyles}
`;
const StyledCopyPasteIcon = styled(CopyPasteIcon)`
    ${IconStyles}
`;
const TrackTitle = styled.div`
    color: white;
    font-weight: 700;
    grid-row: 1;
    grid-column-start: 1;
    grid-column-end: 3;
`;

const TrackDaysContainer = styled.div`
    grid-row-start: 1;
    grid-row-end: 1;
    grid-column-start: 2;
    grid-column-end: 2;
    background-color: white;
    display: grid;
    grid-template-rows: 1fr;
    grid-template-columns: repeat(${(props) => props.weekCount * 7}, 1fr);
    border-radius: 5px;
    overflow: hidden;
`;
const TrackSubTitle = styled.div`
    color: white;
    font-size: 12px;
    grid-row: ${(props) => props.row};
    grid-column: 2;
`;
class Track extends React.Component {
    constructor(props) {
        super(props);
        props.setCurrTrackID(props.id);
        this.state = {
            event_modal: false,
            event_details: false,
            newEvent: true,
        };
    }
    getRowCount = () => {
        if (this.props.arrangedJobpostingsAsArray.length > 0) {
            let postings = _.compact(
                this.props.arrangedJobpostingsAsArray.map((e, i) => {
                    if (this.props.events[e.uid])
                        return this.props.events[e.uid].track_id ===
                            this.props.id
                            ? e
                            : null;
                    return null;
                })
            );

            if (postings.length < 1) return 1;
            let countArr = postings.map((e) => {
                let fEvent = this.props.events[e.uid];
                let count = 1;
                postings.map((f) => {
                    let sEvent = this.props.events[f.uid];
                    if (
                        e.uid !== f.uid &&
                        this.isOverlapping(
                            fEvent.start_date,
                            fEvent.end_date,
                            sEvent.start_date,
                            sEvent.end_date
                        )
                    ) {
                        count++;
                    }
                    return null;
                });

                return count;
            });
            return Math.max.apply(Math, countArr);
        } else return 0;
    };
    isOverlapping(fStart, fEnd, sStart, sEnd) {
        let format = "DD-MM-YYYY";
        if (fStart && fEnd && sStart && sEnd) {
            fStart = moment(fStart, format);
            fEnd = moment(fEnd, format);
            sStart = moment(sStart, format);
            sEnd = moment(sEnd, format);
            if (
                sStart.isBetween(fStart, fEnd, undefined, "[]") ||
                sEnd.isBetween(fStart, fEnd, undefined, "[]")
            )
                return true;
            else return false;
        } else return false;
    }
    render() {
        return (
            <TrackContainer
                rows={this.getRowCount()}
                trackCount={this.props.trackCount}
                sidebarWidth={this.props.sidebarWidth}
            >
                <TrackSidebar>
                    <TrackTitle>{this.props.name}</TrackTitle>
                    <TrackSubTitle row={2}>
                        <b>Department:</b>{" "}
                        {this.props.department ? this.props.department : "None"}
                    </TrackSubTitle>
                    <TrackSubTitle row={3}>
                        <b>Area:</b>{" "}
                        {this.props.area ? this.props.area : "None"}
                    </TrackSubTitle>
                    <IconButtonContainer column={3} row={1}>
                        <StyledIconButton
                            color={"white"}
                            onClick={() =>
                                this.props.removeTrack(this.props.id)
                            }
                        >
                            <StyledClearIcon />
                        </StyledIconButton>
                        <StyledIconButton
                        disabled={this.props.canCreate===false}
                            color={"white"}
                            onClick={() =>
                                this.props.addNewEvent(
                                    this.props.id,
                                    this.props.department,
                                    this.props.area
                                )
                            }
                        >
                            <StyledAddIcon />
                        </StyledIconButton>
                        {this.props.canUpdate&&<StyledIconButton
                        
                            color={
                                this.props.copiedEvent ? "white" : "lightgrey"
                            }
                            disabled={this.props.copiedEvent ? false : true}
                            onClick={() =>
                                this.props.pasteEvent(
                                    this.props.id,
                                    this.props.copiedEvent,
                                    this.props.department,
                                    this.props.area
                                )
                            }
                        >
                            <StyledCopyPasteIcon />
                        </StyledIconButton>}
                    </IconButtonContainer>
                </TrackSidebar>
                <TrackDaysContainer weekCount={this.props.weekCount} title={""}>
                    <EventsContainer
                        track_id={this.props.id}
                        duration={this.props.duration}
                        weekCount={this.props.weekCount}
                        editEvent={this.props.editEvent}
                    />
                    <DragSensorCells
                        track_id={this.props.id}
                        duration={this.props.duration}
                        weekCount={this.props.weekCount}
                    />
                </TrackDaysContainer>
            </TrackContainer>
        );
    }
}
export default hot(module)(
    React.memo(
        connect(
            (store) => {
                return {
                    weekCount: selectWeekCount(store),
                    rowCount: selectRowCount(store),
                    arrangedJobpostingsAsArray: selectArrangedJobpostingsAsArray(
                        store
                    ),
                    selectedJobpostingID: selectSelectedJobpostingID(store),
                    jobpostings: selectRawJobpostings(store),
                    copiedEvent: selectCopyPasteEvent(store),
                    events: selectEvents(store),
                    canCreate:canCreate(store),
                    canDelete:canDelete(store),
                    canUpdate:canUpdate(store),
                };
            },
            { removeTrack, setCurrTrackID, pasteEvent }
        )(Track)
    )
);
